export default __webpack_public_path__ + "static/media/logo-sobatpajak.244cf48d.svg";